export default "__VITE_ASSET__BxAUzapI__"